module.exports = __webpack_public_path__ + "static/CoconutMoving-173b9714c9cd0d799d0c9b99196b0c7e.gif";